import ResultPage from './Result/index.vue'
import CoursePage from './Course/index.vue'
import UploadPage from './Upload/index.vue'
import LoadingPage from './Loading/index.vue'
import HomePage from './Home/index.vue'
import ErrorPage from './Erroring/index.vue'

export const Result = ResultPage
export const Course = CoursePage
export const Upload = UploadPage
export const Loading = LoadingPage
export const Home = HomePage
export const Erroring = ErrorPage



// WEBPACK FOOTER //
// ./src/components/index.js